import { Vehicle } from '../types';

import Rule from '@/common/components/rule';
import { capitalizeOnlyFirstLetter } from '@/util-conversion/misc/capitalize-only-first-letter';
import React from 'react';

interface VehicleBasicInfoProps {
  vehicle: Vehicle;
}

export default function VehicleBasicInfo({ vehicle }: VehicleBasicInfoProps) {
  const items = [
    {
      title: vehicle?.is_electric ? 'MPGe' : 'MPG',
      value: `${vehicle?.fuel_efficiency_city ? `${vehicle.fuel_efficiency_city}` : '--'}${
        vehicle?.fuel_efficiency_highway
          ? ` / ${vehicle.fuel_efficiency_highway}`
          : ' / --'
      }`,
    },
    {
      title: 'Mileage',
      value: vehicle.odometer
        ? `${vehicle.odometer.toLocaleString('en-US', { maximumFractionDigits: 0 })}`
        : '',
    },
    {
      title: 'Drivetrain',
      value: vehicle.drivetrain ? vehicle.drivetrain : '',
    },
    {
      title: 'Color',
      value: vehicle.exterior_color_basic
        ? capitalizeOnlyFirstLetter(vehicle.exterior_color_basic)
        : '',
    },
  ];

  return (
    <div className="flex w-full justify-between gap-[8px]">
      {items.map((item: { title: string; value: string }, index: number) => (
        <React.Fragment key={`vbi-parent-${index}`}>
          <div className="flex min-w-[65px] flex-col items-center">
            <p className="body3 text-center text-flexcar-neutral70">{item.title}</p>
            <p className="body2-strong text-center text-flexcar-neutral1">{item.value}</p>
          </div>
          {index !== items.length - 1 ? (
            <Rule direction="vertical" className="h-auto" />
          ) : null}
        </React.Fragment>
      ))}
    </div>
  );
}
